"use strict";
function __export(m) {
  for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const cloudProviderFromNodeTypes_1 = require("./cloudProviderFromNodeTypes");
const NodeTypeMapper_1 = require("./NodeTypeMapper");
var BasicNode_1 = require("./BasicNode");
exports.BasicNode = BasicNode_1.BasicNode;
var TriggerNode_1 = require("./TriggerNode");
exports.TriggerNode = TriggerNode_1.TriggerNode;
var ResourceNode_1 = require("./ResourceNode");
exports.ResourceNode = ResourceNode_1.ResourceNode;
var FilterNode_1 = require("./FilterNode");
exports.FilterNode = FilterNode_1.FilterNode;
var ActionNode_1 = require("./ActionNode");
exports.ActionNode = ActionNode_1.ActionNode;
var ReportNode_1 = require("./ReportNode");
exports.ReportNode = ReportNode_1.ReportNode;
var NotificationNode_1 = require("./NotificationNode");
exports.NotificationNode = NotificationNode_1.NotificationNode;
var UserApprovalNode_1 = require("./UserApprovalNode");
exports.UserApprovalNode = UserApprovalNode_1.UserApprovalNode;
var CustomNode_1 = require("./CustomNode");
exports.CustomNode = CustomNode_1.CustomNode;
var DelayNode_1 = require("./DelayNode");
exports.DelayNode = DelayNode_1.DelayNode;
var HttpNode_1 = require("./HttpNode");
exports.HttpNode = HttpNode_1.HttpNode;
var JenkinsNode_1 = require("./JenkinsNode");
exports.JenkinsNode = JenkinsNode_1.JenkinsNode;
var MonitoringNode_1 = require("./MonitoringNode");
exports.MonitoringNode = MonitoringNode_1.MonitoringNode;
var WorkflowNode_1 = require("./WorkflowNode");
exports.WorkflowNode = WorkflowNode_1.WorkflowNode;
var SSHNode_1 = require("./SSHNode");
exports.SSHNode = SSHNode_1.SSHNode;
var NetworkNode_1 = require("./NetworkNode");
exports.NetworkScanNode = NetworkNode_1.NetworkScanNode;
var WolkenNode_1 = require("./WolkenNode");
exports.WolkenNode = WolkenNode_1.WolkenNode;
var VmwareNode_1 = require("./VmwareNode");
exports.VmwareNode = VmwareNode_1.VmwareNode;
var VmwareActionNode_1 = require("./VmwareActionNode");
exports.VmwareActionNode = VmwareActionNode_1.VmwareActionNode;
var ParallelNode_1 = require("./ParallelNode");
exports.ParallelNode = ParallelNode_1.ParallelNode;
var DecisionNode_1 = require("./DecisionNode");
exports.DecisionNode = DecisionNode_1.DecisionNode;
var K8ActionNode_1 = require("./K8ActionNode");
exports.K8ActionNode = K8ActionNode_1.K8ActionNode;
var K8ResourceNode_1 = require("./K8ResourceNode");
exports.K8ResourceNode = K8ResourceNode_1.K8ResourceNode;
var TerraformActionNode_1 = require("./TerraformActionNode");
exports.TerraformActionNode = TerraformActionNode_1.TerraformActionNode;
var TerraformResourceNode_1 = require("./TerraformResourceNode");
exports.TerraformResourceNode = TerraformResourceNode_1.TerraformResourceNode;
var DataJoinerNode_1 = require("./DataJoinerNode");
exports.DataJoinerNode = DataJoinerNode_1.DataJoinerNode;
var DataFormatterNode_1 = require("./DataFormatterNode");
exports.DataFormatterNode = DataFormatterNode_1.DataFormatterNode;
var UserDefinedNode_1 = require("./UserDefinedNode");
exports.UserDefinedNode = UserDefinedNode_1.UserDefinedNode;
var GCPActionNode_1 = require("./GCPActionNode");
exports.GCPActionNode = GCPActionNode_1.GCPActionNode;
var GCPResourceNode_1 = require("./GCPResourceNode");
exports.GCPResourceNode = GCPResourceNode_1.GCPResourceNode;
__export(require("./cloudProviderFromNodeTypes"));
__export(require("./groupNodesByCloudProvider"));
function initialiseUserDefinedNodes(nodeDefinitions) {
  for (const nodeDefinition of nodeDefinitions) {
    cloudProviderFromNodeTypes_1.extendCloudProvider(nodeDefinition);
    NodeTypeMapper_1.extendNodeTypeMapper(nodeDefinition);
  }
}
exports.initialiseUserDefinedNodes = initialiseUserDefinedNodes;
//# sourceMappingURL=index.js.map
